import { render, staticRenderFns } from "./CbsConstructorJoinCard.vue?vue&type=template&id=3dd82356&scoped=true"
import script from "./CbsConstructorJoinCard.vue?vue&type=script&lang=js"
export * from "./CbsConstructorJoinCard.vue?vue&type=script&lang=js"
import style0 from "./CbsConstructorJoinCard.vue?vue&type=style&index=0&id=3dd82356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd82356",
  null
  
)

export default component.exports